import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { AdContainer } from "../../ads";

import Separator from "../../atoms/separator";

import "./billboard-ad.m.css";

const BillBoardCollectionAd = ({ collection, index }) => {
  const adUnitId = get(collection, ["associated-metadata", "adUnitId"], "");
  const [isMobile, setMobile] = useState(false);
  const [display, setDisplay] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
      setDisplay(true);
    } else {
      setMobile(false);
      setDisplay(true);
    }
  }, []);

  const adsId = {
    DH_Desktop_HP_Billboard_Top: "div-gpt-ad-1680156194475-0",
    DH_Desktop_HP_Billboard_Mid: "div-gpt-ad-1680156254107-0",
    DH_Desktop_HP_Billboard_Bottom: "div-gpt-ad-1680155832150-0"
  };

  return (
    <div styleName="bill-board-ad-col-wrapper">
      <div styleName={`main-seperator-wrapper ${index === 0 ? "show" : ""}`}>
        {display && !isMobile && index === 0 ? (
          <div id={`bill-board-collection-ad-top-separator-0`}>
            <Separator />
          </div>
        ) : null}
      </div>
      {!isMobile ? (
        <div styleName={index === 0 ? "ad-wrapper ad-bgc" : "ad-wrapper"} className="hide-mobile">
          <AdContainer AdClassName="standard-970x250" id={adsId[adUnitId]} desktop={adUnitId} />
        </div>
      ) : null}
      {display && !isMobile ? (
        <div id={`bill-board-collection-ad-separator-${index}`}>
          <Separator />
        </div>
      ) : null}
    </div>
  );
};

export default BillBoardCollectionAd;
